import "./HeroHeader.css";

const HeroHeader = ({ title = "", subtitle = "" }) => {
  return (
    <section className="hero-header">
      <div className="container">
        <div className="about-hero-content">
          <h1>{title}</h1>
          <p className="hero-subtitle">{subtitle}</p>
        </div>
      </div>
    </section>
  );
};

export default HeroHeader;
